import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getData } from "../Services/api";

const OrderDetails = () => {
    const { id } = useParams();
    const [values, setValues] = useState(null);

    const fetchOrder = async () => {
        try {
            const res = await getData(`/orders/${id}`);
            if (res.status) {
                setValues(res.data);
            }
        } catch (error) {
            console.log("error fetch order", error);
        }
    };

    useEffect(() => {
        fetchOrder();
    }, [id]);

    if (!values) {
        return (
            <div className="container py-5 text-center">
                <div className="spinner-border text-primary"></div>
            </div>
        );
    }

    return (
        <div className="pc-container">
            <div className="pc-content">
                {/* ================= ORDER HEADER ================= */}
                <div className="card shadow-sm mb-4">
                    <div className="card-body d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                        <div>
                            <h4 className="mb-1">Order #{values.orderId}</h4>
                            <small className="text-muted">
                                Placed on {new Date(values.createdAt).toLocaleString()}
                            </small>
                        </div>

                        <div className="mt-3 mt-md-0">
                            <span className="badge bg-success me-2">
                                {values.paymentStatus}
                            </span>
                            <span className="badge bg-primary">
                                {values.orderStatus}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {/* ================= SHIPPING ADDRESS ================= */}
                    <div className="col-lg-4 mb-4">
                        <div className="card shadow-sm h-100">
                            <div className="card-header bg-light fw-semibold">
                                Shipping Address
                            </div>
                            <div className="card-body">
                                <p className="mb-1 fw-bold">{values.shippingAddress.fullName}</p>
                                <p className="mb-1">{values.shippingAddress.addressLine}</p>
                                <p className="mb-1">
                                    {values.shippingAddress.city},{" "}
                                    {values.shippingAddress.state},{" "}
                                    {values.shippingAddress.postalCode}
                                </p>
                                <p className="mb-1">{values.shippingAddress.country}</p>
                                <p className="mb-0">📞 {values.shippingAddress.phone}</p>
                            </div>
                        </div>
                    </div>

                    {/* ================= ORDER SUMMARY ================= */}
                    <div className="col-lg-8 mb-4">
                        <div className="card shadow-sm h-100">
                            <div className="card-header bg-light fw-semibold">
                                Order Summary
                            </div>
                            <div className="card-body">
                                <div className="d-flex justify-content-between mb-2">
                                    <span>Subtotal</span>
                                    <span>₹{values.subtotal}</span>
                                </div>
                                <div className="d-flex justify-content-between mb-2">
                                    <span>Shipping</span>
                                    <span>₹{values.shipping}</span>
                                </div>
                                <div className="d-flex justify-content-between mb-2">
                                    <span>Discount</span>
                                    <span className="text-danger">- ₹{values.discount}</span>
                                </div>
                                <div className="d-flex justify-content-between mb-2">
                                    <span>Tax</span>
                                    <span>₹{values.tax}</span>
                                </div>
                                <hr />
                                <div className="d-flex justify-content-between fw-bold fs-5">
                                    <span>Total</span>
                                    <span>₹{values.totalAmount}</span>
                                </div>

                                <hr />
                                <p className="mb-1">
                                    <strong>Payment Method:</strong> {values.paymentMethod}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ================= ORDER ITEMS ================= */}
                <div className="card shadow-sm mb-4">
                    <div className="card-header bg-light fw-semibold">
                        Order Items
                    </div>
                    <div className="table-responsive">
                        <table className="table align-middle mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>Product</th>
                                    <th>Price</th>
                                    <th>Qty</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {values.items.map((item) => (
                                    <tr key={item._id}>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <img
                                                    src={item.product.images[0]}
                                                    alt={item.product.name}
                                                    width="60"
                                                    height="60"
                                                    className="rounded me-3"
                                                    style={{ objectFit: "cover" }}
                                                />
                                                <div>
                                                    <p className="mb-0 fw-semibold">
                                                        {item.product.name}
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                        <td>₹{item.priceAtPurchase}</td>
                                        <td>{item.quantity}</td>
                                        <td>
                                            ₹{item.priceAtPurchase * item.quantity}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* ================= STATUS HISTORY ================= */}
                <div className="card shadow-sm">
                    <div className="card-header bg-light fw-semibold">
                        Order Timeline
                    </div>
                    <div className="card-body">
                        {values.statusHistory.map((history, index) => (
                            <div key={index} className="mb-3">
                                <span className="badge bg-info me-2">
                                    {history.status}
                                </span>
                                <small className="text-muted">
                                    {new Date(history.changedAt).toLocaleString()}
                                </small>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderDetails;
